<div class="status-history-container" id="status-history-container">
  <ptg-title-bar
    [name]="data.serviceHistory ? 'Edit' : 'Add New'"
    [viewName]="data.viewName"
    [onlyTitle]="true"
  ></ptg-title-bar>

  <ptg-overview-header-entity
    [isShowChangeMemberDetailBtn]="false"
    [shouldHideCloseButton]="true"
    [injectedMemberId]="memberId"
  >
  </ptg-overview-header-entity>

  <div *ngIf="!isLoading && !isFormLoading">
    <form [formGroup]="editForm">
      <div class="flex flex-wrap gap-3">
        <ptg-button buttonName="Save" classInput="primary" (clickButton)="onSubmit()"></ptg-button>
        <ptg-button buttonName="Cancel" classInput="tertiary" (clickButton)="onCancel()"></ptg-button>
      </div>
      <div class="form-control-container">
        <div class="form-control-date">
          <ptg-datepicker
            placeholder="Begin Date"
            class="input-field"
            [controlField]="beginDate"
            customError="beginDateErrorMessage"
          ></ptg-datepicker>
          <ptg-datepicker
            placeholder="End Date"
            class="input-field"
            [controlField]="endDate"
            customError="endDateErrorMessage"
            errorAsync="End Date had an overlap service record."
          ></ptg-datepicker>
        </div>
        <div class="municipality-label">
          <span>Municipality</span>
          <p>{{ municipalityName }}</p>
        </div>
      </div>
    </form>
  </div>
  <div id="loading-table" *ngIf="isLoading || isFormLoading">
    <div class="wrap-item">
      <mat-progress-spinner role="progressbar" aria-label="Progress Spinner" diameter="50" mode="indeterminate">
      </mat-progress-spinner>
      <p>Loading...</p>
    </div>
  </div>
</div>
